module.exports = __webpack_public_path__ + "img/jhf_fav_col.c4de7f16.svg";